module.exports = __webpack_public_path__ + "img/fj.3ea77802.svg";